import PropTypes from 'prop-types';
import React from 'react';
import AvatarIcon from '../atoms/AvatarIcon';
import css from './AvatarOverflow.css';

const AvatarOverflow = ({ count }) => (
    <AvatarIcon>{count > 0 ? <span className={count < 100 ? css.big : css.small}>+{count}</span> : null}</AvatarIcon>
);

AvatarOverflow.propTypes = {
    count: PropTypes.number,
};

export default AvatarOverflow;
